//
//
//
//
//
//

// toast信息提示
export default {
    replace: true,
    props: {
        showMessage: String,    // toast显示的内容
        isShow: Boolean     // toast是否显示
    },
    computed: {
        showWidth() {   // 根据文字的内容多少来决定toast的宽度
            if (this.showMessage && this.showMessage.length > 11) {
                return true;
            } else {
                return false;
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/common/toast.vue